import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Version`}</h3>
    <p>{`8.19.1`}</p>
    <h3>{`Description`}</h3>
    <p>{`npm is the package manager for the Node JavaScript platform.  It puts
modules in place so that node can find them, and manages dependency
conflicts intelligently.`}</p>
    <p>{`It is extremely configurable to support a variety of use cases.  Most
commonly, you use it to publish, discover, install, and develop node
programs.`}</p>
    <p>{`Run `}<inlineCode parentName="p">{`npm help`}</inlineCode>{` to get a list of available commands.`}</p>
    <h3>{`Important`}</h3>
    <p>{`npm comes preconfigured to use npm's public registry at
`}<a parentName="p" {...{
        "href": "https://registry.npmjs.org"
      }}>{`https://registry.npmjs.org`}</a>{` by default. Use of the npm public registry is
subject to terms of use available at
`}<a parentName="p" {...{
        "href": "https://docs.npmjs.com/policies/terms"
      }}>{`https://docs.npmjs.com/policies/terms`}</a>{`.`}</p>
    <p>{`You can configure npm to use any compatible registry you like, and even
run your own registry. Use of someone else's registry is governed by
their terms of use.`}</p>
    <h3>{`Introduction`}</h3>
    <p>{`You probably got npm because you want to install stuff.`}</p>
    <p>{`The very first thing you will most likely want to run in any node
program is `}<inlineCode parentName="p">{`npm install`}</inlineCode>{` to install its dependencies.`}</p>
    <p>{`You can also run `}<inlineCode parentName="p">{`npm install blerg`}</inlineCode>{` to install the latest version of
"blerg".  Check out `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-install"
      }}><inlineCode parentName="a">{`npm install`}</inlineCode></a>{` for more
info.  It can do a lot of stuff.`}</p>
    <p>{`Use the `}<inlineCode parentName="p">{`npm search`}</inlineCode>{` command to show everything that's available in the
public registry.  Use `}<inlineCode parentName="p">{`npm ls`}</inlineCode>{` to show everything you've installed.`}</p>
    <h3>{`Dependencies`}</h3>
    <p>{`If a package lists a dependency using a git URL, npm will install that
dependency using the `}<a parentName="p" {...{
        "href": "https://github.com/git-guides/install-git"
      }}><inlineCode parentName="a">{`git`}</inlineCode></a>{`
command and will generate an error if it is not installed.`}</p>
    <p>{`If one of the packages npm tries to install is a native node module and
requires compiling of C++ Code, npm will use
`}<a parentName="p" {...{
        "href": "https://github.com/nodejs/node-gyp"
      }}>{`node-gyp`}</a>{` for that task.
For a Unix system, `}<a parentName="p" {...{
        "href": "https://github.com/nodejs/node-gyp"
      }}>{`node-gyp`}</a>{`
needs Python, make and a buildchain like GCC. On Windows,
Python and Microsoft Visual Studio C++ are needed. For more information
visit `}<a parentName="p" {...{
        "href": "https://github.com/nodejs/node-gyp"
      }}>{`the node-gyp repository`}</a>{` and
the `}<a parentName="p" {...{
        "href": "https://github.com/nodejs/node-gyp/wiki"
      }}>{`node-gyp Wiki`}</a>{`.`}</p>
    <h3>{`Directories`}</h3>
    <p>{`See `}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/folders"
      }}><inlineCode parentName="a">{`folders`}</inlineCode></a>{` to learn about where npm puts
stuff.`}</p>
    <p>{`In particular, npm has two modes of operation:`}</p>
    <ul>
      <li parentName="ul">{`local mode:
npm installs packages into the current project directory, which
defaults to the current working directory.  Packages install to
`}<inlineCode parentName="li">{`./node_modules`}</inlineCode>{`, and bins to `}<inlineCode parentName="li">{`./node_modules/.bin`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`global mode:
npm installs packages into the install prefix at
`}<inlineCode parentName="li">{`$npm_config_prefix/lib/node_modules`}</inlineCode>{` and bins to
`}<inlineCode parentName="li">{`$npm_config_prefix/bin`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`Local mode is the default.  Use `}<inlineCode parentName="p">{`-g`}</inlineCode>{` or `}<inlineCode parentName="p">{`--global`}</inlineCode>{` on any command to
run in global mode instead.`}</p>
    <h3>{`Developer Usage`}</h3>
    <p>{`If you're using npm to develop and publish your code, check out the
following help topics:`}</p>
    <ul>
      <li parentName="ul">{`json:
Make a package.json file.  See
`}<a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/package-json"
        }}><inlineCode parentName="a">{`package.json`}</inlineCode></a>{`.`}</li>
      <li parentName="ul">{`link:
Links your current working code into Node's path, so that you don't
have to reinstall every time you make a change.  Use `}<a parentName="li" {...{
          "href": "/cli/v8/commands/npm-link"
        }}><inlineCode parentName="a">{`npm
link`}</inlineCode></a>{` to do this.`}</li>
      <li parentName="ul">{`install:
It's a good idea to install things if you don't need the symbolic
link.  Especially, installing other peoples code from the registry is
done via `}<a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}><inlineCode parentName="a">{`npm install`}</inlineCode></a></li>
      <li parentName="ul">{`adduser:
Create an account or log in.  When you do this, npm will store
credentials in the user config file.`}</li>
      <li parentName="ul">{`publish:
Use the `}<a parentName="li" {...{
          "href": "/cli/v8/commands/npm-publish"
        }}><inlineCode parentName="a">{`npm publish`}</inlineCode></a>{` command to upload your
code to the registry.`}</li>
    </ul>
    <h4>{`Configuration`}</h4>
    <p>{`npm is extremely configurable.  It reads its configuration options from
5 places.`}</p>
    <ul>
      <li parentName="ul">{`Command line switches:
Set a config with `}<inlineCode parentName="li">{`--key val`}</inlineCode>{`.  All keys take a value, even if they
are booleans (the config parser doesn't know what the options are at
the time of parsing).  If you do not provide a value (`}<inlineCode parentName="li">{`--key`}</inlineCode>{`) then
the option is set to boolean `}<inlineCode parentName="li">{`true`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Environment Variables:
Set any config by prefixing the name in an environment variable with
`}<inlineCode parentName="li">{`npm_config_`}</inlineCode>{`.  For example, `}<inlineCode parentName="li">{`export npm_config_key=val`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`User Configs:
The file at `}<inlineCode parentName="li">{`$HOME/.npmrc`}</inlineCode>{` is an ini-formatted list of configs.  If
present, it is parsed.  If the `}<inlineCode parentName="li">{`userconfig`}</inlineCode>{` option is set in the cli
or env, that file will be used instead.`}</li>
      <li parentName="ul">{`Global Configs:
The file found at `}<inlineCode parentName="li">{`./etc/npmrc`}</inlineCode>{` (relative to the global prefix will be
parsed if it is found.  See `}<a parentName="li" {...{
          "href": "/cli/v8/commands/npm-prefix"
        }}><inlineCode parentName="a">{`npm prefix`}</inlineCode></a>{` for
more info on the global prefix.  If the `}<inlineCode parentName="li">{`globalconfig`}</inlineCode>{` option is set
in the cli, env, or user config, then that file is parsed instead.`}</li>
      <li parentName="ul">{`Defaults:
npm's default configuration options are defined in
lib/utils/config-defs.js.  These must not be changed.`}</li>
    </ul>
    <p>{`See `}<a parentName="p" {...{
        "href": "/cli/v8/using-npm/config"
      }}><inlineCode parentName="a">{`config`}</inlineCode></a>{` for much much more information.`}</p>
    <h3>{`Contributions`}</h3>
    <p>{`Patches welcome!`}</p>
    <p>{`If you would like to help, but don't know what to work on, read the
`}<a parentName="p" {...{
        "href": "https://github.com/npm/cli/blob/latest/CONTRIBUTING.md"
      }}>{`contributing
guidelines`}</a>{` and
check the issues list.`}</p>
    <h3>{`Bugs`}</h3>
    <p>{`When you find issues, please report them:
`}<a parentName="p" {...{
        "href": "https://github.com/npm/cli/issues"
      }}>{`https://github.com/npm/cli/issues`}</a></p>
    <p>{`Please be sure to follow the template and bug reporting guidelines.`}</p>
    <h3>{`Feature Requests`}</h3>
    <p>{`Discuss new feature ideas on our discussion forum:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/npm/feedback"
        }}>{`https://github.com/npm/feedback`}</a></li>
    </ul>
    <p>{`Or suggest formal RFC proposals:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/npm/rfcs"
        }}>{`https://github.com/npm/rfcs`}</a></li>
    </ul>
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-help"
        }}>{`npm help`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/package-json"
        }}>{`package.json`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/npmrc"
        }}>{`npmrc`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}>{`npm install`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-prefix"
        }}>{`npm prefix`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-publish"
        }}>{`npm publish`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      